import {
  NOTIFICATION_SECTION,
  type Notification
} from "../types/notification.types.ts"

// Matches the server's own count, which is the authority: one that labels
// sections counts what needs attention, and one too old to label counts every
// unread row.
export function countsTowardsBell(notification?: Notification): boolean {
  if (!notification) return false

  return (
    notification.section === undefined ||
    notification.section === NOTIFICATION_SECTION.NEEDS_ATTENTION
  )
}
